const statisticsSi = {
    "user_statistics": "Statistika uporabnikov",
    "menu_item_clicks": "Kliki na elemente menija",
    "statistics": "Statistika",
    "user_traffic": "Uporabniški promet",
    "last_7_days": "Zadnjih 7 dni",
    "last_30_days": "Zadnjih 30 dni",
    "menu_item": "Element menija",
    "click_count": "Število klikov",
    "error_fetching_user_statistics": "Napaka pri pridobivanju statističnih podatkov o uporabnikih.",
    "error_fetching_menu_item_statistics": "Napaka pri pridobivanju statističnih podatkov o elementih menija.",
    "statistics_feature_not_available": "Funkcija statistike je na voljo samo v paketu PRO. Za dostop do te funkcije nadgradite svojo naročnino.",
    "change_subscription_plan": "Spremeni naročniški paket",
    "permission_denied": "Dovoljenje zavrnjeno",
    "error_fetching_rating_statistics": "Napaka pri pridobivanju statističnih podatkov o ocenah.",
    "menu_item_ratings": "Ocene elementov menija",
    "likes": "všečki",
    "dislikes": "ni všeč",
    "rating_trends_last_7_days": "Trendi ocenjevanja (zadnjih 7 dni)",
    "rating_trends_last_30_days": "Trendi ocenjevanja (zadnjih 30 dni)",
    "kpi_total_visitors": "Skupaj obiskovalcev",
    "kpi_avg_per_day": "Povp. / dan",
    "kpi_peak_day": "Vrhunski dan",
    "kpi_top_item": "Najbolj klikana jed",
    "kpi_clicks": "klikov",
    "kpi_vs_prev": "glede na prejšnje obdobje",
    "current_period": "Trenutno obdobje",
    "previous_period": "Prejšnje obdobje",
    "visitors": "obiskovalcev",
    "hourly_traffic": "Urni promet",
    "utm_sources": "Viri prometa",
    "utm_unknown": "Neznano",
    "no_data": "Ni podatkov",
};

export default statisticsSi;
